<template>
  <div class="weixin-tip">
    <van-icon name="checked" color="#07c160"/>
    <h4 class="weui_msg_title">您已取消支付</h4>
    <van-button type="primary" size="small" @click="toPayList">返回个人中心查看</van-button>
  </div>
</template>

<script>
export default {
  name: 'PayResult',
  data() {
    return {
      isCancel: false,
      orderAmount: 0
    }
  },
  created() {
  },
  mounted() {
    this.orderAmount = +this.$route.query.orderAmount
  },
  methods: {
    toPayList() {
      this.$router.push('/My')
    },
  }
}
</script>

<style lang="less" scoped>
.weixin-tip {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;

  .van-icon {
    font-size: 60px;
    color: #10AEFF;
  }

  h4 {
    font-size: 20px;
    font-weight: 400;
    padding: 15px 0;
    margin: 0;
  }

  .small-fee-number {
    color: #ff3b45;
    font-size: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/routerPages/PayResultCancel.vue